import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import Breadcrumb from '../../components/Breadcrumb';
import { get } from '../../services/apiController';
import { dateFormat } from '../../util/helper';
import AgreementAddEditModal from './components/AgreementAddEditModal';
import { EditIcon, ViewIcon } from '../icons';
// import DeleteModal from '../../components/common/DeleteModal';
import { Link } from 'react-router-dom';

function AgreementList() {
  const [filters, setFilters] = useState({ query: '' });
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [agreementList, setAgreementList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [agreementId, setAgreementId] = useState(null);
  // const [deleteModal, setDeleteModal] = useState(false);

  const FetchAgreements = () => {
    get(`/agreements/?query=${filters.query}&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`)
      .then((res) => {
        setTotalRecords(res?.data?.count);
        setAgreementList(res?.data?.rows);
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message || err?.response?.data?.message || err?.message));
  };

  const handleEdit = (e, agreementId) => {
    setAgreementId(agreementId);
    setShowModal(true);
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        FetchAgreements();
      }
    },
    [filters],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    FetchAgreements();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb navigation={[{ link: '#', title: 'Agreement List' }]} />
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <div className="form-group col-md-2 col-lg-3">
              <input
                type="search"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Search your query (name, phone, Ref.)"
                value={filters.query}
                onChange={(e) => setFilters({ ...filters, query: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Agreement | {totalRecords ?? 0}
          </h4>
          <button onClick={() => setShowModal(true)} type="button" className="btn app-btn-default dark-color">
            Create
          </button>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered className="bill-detail-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Location</th>
                    <th>Type</th>
                    <th>Ref. Location</th>
                    <th>Owners Name</th>
                    <th>Tenant Name</th>
                    <th>Tenant Phone Number</th>
                    <th>Effective Date</th>
                    <th>Executed Date</th>
                    <th>End Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {agreementList.map((item, index) => {
                    let rowspan = 1;
                    if (index > 0 && item?.branchId === agreementList[index - 1]?.branchId) {
                      rowspan = 0;
                    } else {
                      for (let i = index + 1; i < agreementList.length; i++) {
                        if (item?.branchId === agreementList[i]?.branchId) {
                          rowspan++;
                        } else {
                          break;
                        }
                      }
                    }
                    return (
                      <tr key={index}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        {rowspan > 0 && (
                          <td rowspan={rowspan}>
                            {item?.Branch?.name} ({item?.Branch?.number})
                          </td>
                        )}
                        {rowspan > 0 && (
                          <td rowspan={rowspan} className="text-capitalize">
                            {item?.Branch?.type}
                          </td>
                        )}
                        <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>{item?.referenceLocation}</td>
                        <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>
                          {item?.OwnerDetails?.map((owner) => owner?.ownerName).join(', ')}
                        </td>
                        <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>{item?.tenantName}</td>
                        <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>{item?.tenantPhoneNo}</td>
                        <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>{dateFormat(item?.effectiveDate)}</td>
                        <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>
                          {dateFormat(item?.agreementExecutedDate)}
                        </td>
                        <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>{dateFormat(item?.agreementEndDate)}</td>
                        {item.isShopClosed ? (
                          <td className="highlightCell">
                            <span>Shop Closed</span>
                            <Link to={`/agr/agreement-list/${item?.id}`} className="view-icon m-0">
                              <ViewIcon style={{ color: 'purple' }} />
                            </Link>
                          </td>
                        ) : item.isPreClosed ? (
                          <td className="highlightCell">
                            <span>Pre-Closed</span>
                            <Link to={`/agr/agreement-list/${item?.id}`} className="view-icon m-0">
                              <ViewIcon style={{ color: 'purple' }} />
                            </Link>
                          </td>
                        ) : (
                          <td className="actions">
                            <Link to={`/agr/agreement-list/${item?.id}`} className="view-icon m-0">
                              <ViewIcon style={{ color: 'purple' }} />
                            </Link>
                            <span onClick={(e) => handleEdit(e, item?.id)} className="edit-icon">
                              <EditIcon style={{ color: 'teal' }} />
                            </span>
                            {/* <Link
                            onClick={(e) => {
                              setDeleteModal(true);
                              setAgreementId(item.id);
                            }}
                            className="delete"
                          >
                            <DeleteIcon />
                          </Link> */}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <AgreementAddEditModal
          open={showModal}
          onClose={() => {
            setShowModal(false);
            setAgreementId(null);
          }}
          agreementId={agreementId}
          callback={FetchAgreements}
          step={1}
        />
      )}
      {/* {deleteModal && (
        <DeleteModal
          title="Delete Agreement"
          description="Are you sure? Action cannot be undone."
          open={deleteModal}
          onClose={() => {
            setDeleteModal(false);
            setAgreementId(null);
          }}
          url={`/agreements/${agreementId}`}
          callback={FetchAgreements}
        />
      )} */}
    </React.Fragment>
  );
}

export default AgreementList;
